import { loadImages, autoLoadComponents } from '@/js/utils/auto-loader.js';

// Initialize shared loaders
const images = loadImages();

import '@/css/main.scss';

const components = autoLoadComponents();

// Block labels (only active when logged in)
import '@/js/block-labels.js';

// GTM tracking utility
import '@/js/gtm-tracking.js';

// Handle HMR updates
if ( import.meta.hot ) {

	// Handle PHP file updates - only reload if not in WordPress admin
	import.meta.hot.on( 'php-file-updated', () => {

		const isAdminPage = window.location.pathname.includes( '/wp-admin/' ) ||
							window.location.pathname.includes( '/wp-login.php' );

		if ( ! isAdminPage ) {
			window.location.reload();
		}

	} );
	
}